export const EXSBORDER_DELETE_RESET = 'EXSBORDER_DELETE_RESET'
export const EXSBORDER_DELETE_SET_ERROR = 'EXSBORDER_DELETE_SET_ERROR'
export const EXSBORDER_DELETE_SET_DELETED = 'EXSBORDER_DELETE_SET_DELETED'
export const EXSBORDER_DELETE_TOGGLE_LOADING = 'EXSBORDER_DELETE_TOGGLE_LOADING'
